import React, { FC } from 'react';
import { Card, CardHeader, CardContent } from 'ceci-ui';
import SummaryChart from '../../../assets/summary-chart.svg';

export type Props = {};

const SummaryCard: FC<Props> = () => {
  return (
    <Card>
      <CardHeader
        title="Menchant Name"
        avatar={<h1>M</h1>} />
      <CardContent>
        <ul>
          <li>Taxa de inadimplência <span>0%</span></li>
          <li>Ticket médio <span>R$ 0,00</span></li>
          <li>Clientes <span>0</span></li>
          <li>Repasse disponível <span>R$ 0,00</span></li>
        </ul>
        <img src={SummaryChart} alt="" style={{ margin: '0 auto' }} />
        <p>últimos pagamentos</p>
        <p>Aguardando primeiro pagamento</p>
      </CardContent>
    </Card>

  );
};

export default SummaryCard;
